<template>
	<b-modal :no-close-on-backdrop="true" :hide-header-close="isLoading" ref="modal" title="Posodobitev statusov ND" :size="modalSize" class="modal-primary" @hidden="clearModalData">
		<CRow v-if="updateSuccess !== true">
			<CCol>
				<b-form-file
					v-model="spOrderItemsUpdateStatusFile"
					:placeholder="uploadPlaceholder"
					drop-placeholder="Povleci datoteko..."
					browse-text="Brskaj"
					@input="uploadOrderAttachments"
					accept=".xls"/>
			</CCol>
		</CRow>
		<CRow v-if="updateSuccess">
			<CCol>
				<b-card>
					<CRow>
						<CCol  class="text-center">
							<CCard color="primary" class="text-center" body-wrapper text-color="white">
								<CCardHeader class="numberCardHeader">Št. vseh ND v izbrani datoteki</CCardHeader>
								<CCardBody><span class="display-3">{{ numOfItemsInFile }}</span></CCardBody>
							</CCard>
						</CCol>
						<CCol  class="text-center">
							<CCard color="primary" class="text-center" body-wrapper text-color="white">
								<CCardHeader class="numberCardHeader">Št. ND z ujemajočo opombo</CCardHeader>
								<CCardBody><span class="display-3">{{ numOfItemsInFileWithAcceptableNotes }}</span></CCardBody>
							</CCard>
						</CCol>
						<CCol  class="text-center">
							<CCard color="primary" class="text-center" body-wrapper text-color="white">
								<CCardHeader class="numberCardHeader">Št. uspešno posodobljenih</CCardHeader>
								<CCardBody><span class="display-3">{{ numSuccefulyUpdatedItems }}</span></CCardBody>
							</CCard>
						</CCol>
						<CCol  class="text-center">
							<CCard color="primary" class="text-center" body-wrapper text-color="white">
								<CCardHeader class="numberCardHeader">Št. uspešno dodanih</CCardHeader>
								<CCardBody><span class="display-3">{{ numSuccefulyAddedItems }}</span></CCardBody>
							</CCard>
						</CCol>
						<CCol  class="text-center">
							<CCard color="primary" class="text-center" body-wrapper text-color="white">
								<CCardHeader class="numberCardHeader">Št. neuspešno posodobljenih</CCardHeader>
								<CCardBody><span class="display-3">{{ numErrors }}</span></CCardBody>
							</CCard>
						</CCol>
					</CRow>
				</b-card>
				<CRow v-if="numSuccefulyUpdatedItems > 0">
					<CCol>
						<b-card>
							<div slot="header">
								<b>Posodobljeni ND</b>
							</div>
							<b-table
								ref="spOrderItemsUpdatedStatus"
								responsive="sm"
								striped
								show-empty
								hover
								:empty-text="spOrderItemsUpdatedStatusProps.empty_text"
								:empty-filtered-text="spOrderItemsUpdatedStatusProps.empty_filtered_text"
								:fields="spOrderItemsUpdatedStatusProps.fields"
								:current-page="spOrderItemsUpdatedStatusProps.currentPage"
								:per-page="spOrderItemsUpdatedStatusProps.itemsPerPage"
								:items="spOrderItemsUpdatedStatusProps.items">
								<template v-slot:cell(oldStatus)="data">
									<b-badge class="text-wrap" v-if="getStatusObject(data.item.oldStatus)" :variant="getStatusObject(data.item.oldStatus).variant">{{ getStatusObject(data.item.oldStatus).label }}</b-badge>
								</template>
								<template v-slot:cell(status)="data">
									<b-badge class="text-wrap" v-if="getStatusObject(data.item.status)" :variant="getStatusObject(data.item.status).variant">{{ getStatusObject(data.item.status).label }}</b-badge>
								</template>
							</b-table>
						</b-card>
					</CCol>
				</CRow>
				<CRow v-if="numSuccefulyAddedItems > 0">
					<CCol>
						<b-card>
							<div slot="header">
								<b>Dodani ND</b>
							</div>
							<b-table
								ref="addedSpOrderItems"
								responsive="sm"
								striped
								show-empty
								hover
								:empty-text="addedSpOrderItemsProps.empty_text"
								:empty-filtered-text="addedSpOrderItemsProps.empty_filtered_text"
								:fields="addedSpOrderItemsProps.fields"
								:current-page="addedSpOrderItemsProps.currentPage"
								:per-page="addedSpOrderItemsProps.itemsPerPage"
								:items="addedSpOrderItemsProps.items">
								<template v-slot:cell(oldStatus)="data">
									<b-badge class="text-wrap" v-if="getStatusObject(data.item.oldStatus)" :variant="getStatusObject(data.item.oldStatus).variant">{{ getStatusObject(data.item.oldStatus).label }}</b-badge>
								</template>
								<template v-slot:cell(status)="data">
									<b-badge class="text-wrap" v-if="getStatusObject(data.item.status)" :variant="getStatusObject(data.item.status).variant">{{ getStatusObject(data.item.status).label }}</b-badge>
								</template>
							</b-table>
						</b-card>
					</CCol>
				</CRow>
			</CCol>
		</CRow>
		<CAlert v-show="message.text != null" :color="message.type">
			{{ message.text }}
		</CAlert>
		<template slot="modal-footer">
			<b-container fluid class="p-0">
				<b-row>
					<b-col align-self="end" class="ma_pos">
						<b-button v-if="sourceItems && sourceItems.length > 0" :disabled="isLoading" style="margin-right:5px;" variant="secondary" @click="onPrint()">Natisni</b-button>

						<b-button v-if="updateSuccess !== true" :disabled="isLoading" style="margin-right:5px;" variant="secondary" @click="onCancelModal()">Prekliči</b-button>
						<b-button :disabled="okButtonDisabled" variant="primary" @click.stop="onOkModal()">{{ okButton.label }}</b-button>
					</b-col>
				</b-row>
			</b-container>
		</template>
		<vue-loading :active.sync="isLoading" :is-full-page="false"/>
	</b-modal>
</template>

<script>
import axios from 'axios';
import settings from '@/settings.js';
const PH_TEXT = 'Izberi ali povleci datoteko ...';

export default {
	name: 'sp-order-items-status-update-from-file-modal',
	components: {
	},
	props: {
	},
	methods: {
		showModal: function () {
			this.$refs.modal.show();
		},
		onOkModal: function () {
			if (this.updateSuccess === true) {
				this.$refs.modal.hide();
				this.clearModalData();
			} else {
				this.startProgress();
				this.uploadFile(this, this.spOrderItemsUpdateStatusFile);
			}
		},
		onCancelModal: function () {
			this.$refs.modal.hide();
		},
		onPrint: function () {
			this.printStickers(this, this.sourceItems);
		},
		clearModalData: function () {
			this.isLoading = false;
			this.title = '';
			this.okButton = {
				label: 'Posodobi',
				progress: false,
				disabled: true
			};
			this.showAlert();
			this.spOrderItemsUpdatedStatusProps.items = [];
			this.sourceItems = [];
			this.numOfItemsInFile = 0;
			this.numOfItemsInFileWithAcceptableNotes = 0;
			this.numItemsInDebt = 0;
			this.numSuccefulyUpdatedItems = 0;
			this.numErrors = 0;
			this.spOrderItemsUpdateStatusFile = null;
			this.updateSuccess = null;
			this.addedSpOrderItemsProps.items = [];
			this.numSuccefulyAddedItems = 0;
		},
		startProgress: function () {
			this.isLoading = true;
			this.okButton.disabled = true;
			this.okButton.progress = true;
		},
		stopProgress: function () {
			this.isLoading = false;
			this.okButton.disabled = false;
			this.okButton.progress = false;
		},
		showAlert: function (message, type, seconds) {
			if (message && type && seconds) {
				this.message.type = type;
				this.message.text = message;
				setTimeout(() => {
					this.showAlert();
				}, seconds * 1000);
			} else if (message && type) {
				this.message.type = type;
				this.message.text = message;
			} else if (message) {
				this.message.type = 'primary';
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		},
		uploadOrderAttachments: function () {
			if (this.spOrderItemsUpdateStatusFile.size > 10485760) {
				this.showError('Datoteka ' + attachment.name + ' je prevelika!')
			}
		},
		printStickers: function (ctx, items) {
			let args = {
				items
			};
			let settings = {
				responseType: 'arraybuffer',
				headers: {
					'Content-Type': 'application/json',
					'Accept': 'application/pdf'
				}
			};
			return axios.post('/sp_order_items/print_sp_orders_delivered', args, settings)
				.then(response => {
					const newBlob = new Blob([response.data], {
						type: response.headers['content-type']
					});
					const data = window.URL.createObjectURL(newBlob);
					var link = document.createElement('a');
					link.href = data;
					link.download = 'Nalepke ' + this.$options.filters.viewDate(new Date()) + '.pdf';
					link.click();
					setTimeout(function () {
						// For Firefox it is necessary to delay revoking the ObjectURL
						window.URL.revokeObjectURL(data)
					}, 100);
					link.remove();
				})
				.catch(error => {
					console.error(error);
				});
		},
		uploadFile: function (ctx, file) {
			let args = new FormData();
			let settings = {
				headers: {
					'content-type': 'multipart/form-data'
				},
				onUploadProgress: function(progressEvent) {
					let loadedPrecent = progressEvent.loaded / progressEvent.total * 100;
				}
			};
			args.append('file', file);
			return axios.post('/sp_order_items/update_statuses_from_file', args, settings)
				.then(response => {
					this.stopProgress();
					this.sourceItems = response.data.sourceItems;
					this.numOfItemsInFile = response.data.numOfItemsInFile;
					this.numOfItemsInFileWithAcceptableNotes = response.data.numOfItemsInFileWithAcceptableNotes;
					this.numItemsInDebt = response.data.numItemsInDebt;
					this.numSuccefulyUpdatedItems = response.data.numSuccefulyUpdatedItems;
					this.numErrors = response.data.numErrorsOnUpdate + response.data.numErrorsOnAdding;
					this.spOrderItemsUpdatedStatusProps.items = response.data.updatedSpOrderItems;
					this.updateSuccess = true;
					this.addedSpOrderItemsProps.items = response.data.addedSpOrderItems;
					this.numSuccefulyAddedItems = response.data.numSuccefulyAddedItems;
					this.okButton.label = 'Končaj';
					this.$emit('emit_spOrderItemsStatusUpdated');
				})
				.catch(error => {
					this.stopProgress();
					this.updateSuccess = false;
					console.error(error);
					if(error.response && error.response.data && error.response.data.code) {
						this.showAlert('Napaka pri posodablanju statusov! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
					} else {
						this.showAlert('Napaka! Prosimo poizkusite kasneje.', this.ALERT_TYPE_ERROR);
					}
				});
		},
		getStatusObject: function (status) {
			let statusObject = settings.spOrderItemsStatusOptions.find((item) => item.value == status);
			if (statusObject) return statusObject;
			return null;
		}
	},
	data: function () {
		return {
			settings,
			isLoading: false,
			title: '',
			okButton: {
				label: 'Posodobi',
				progress: false,
				disabled: true
			},
			message: {
				type: null,
				text: null
			},
			ALERT_TYPE_SUCCESS: 'success',
			ALERT_TYPE_ERROR: 'danger',
			spOrderItemsUpdateStatusFile: null,
			spOrderItemsUpdatedStatusProps: {
				fields: [
					{ key: 'id', label: 'Id' },
					{ key: 'title', label: 'Naziv' },
					{ key: 'catalog_number', label: 'Kataloška št.' },
					{ key: 'note', label: 'Opomba' },
					{ key: 'codeFromFile', label: 'Šifra' },
					{ key: 'notesFromFile', label: 'Opomba v datoteki' },
					{ key: 'oldStatus', label: 'Prejšnji status' },
					{ key: 'status', label: 'Nov status' },
				],
				items: []
			},
			addedSpOrderItemsProps: {
				fields: [
					{ key: 'id', label: 'Id' },
					{ key: 'title', label: 'Naziv' },
					{ key: 'catalog_number', label: 'Kataloška št.' },
					{ key: 'note', label: 'Opomba' },
					{ key: 'codeFromFile', label: 'Šifra' },
					{ key: 'notesFromFile', label: 'Opomba v datoteki' },
					{ key: 'oldStatus', label: 'Prejšnji status' },
					{ key: 'status', label: 'Nov status' },
				],
				items: []
			},
			sourceItems: [],
			numOfItemsInFile: 0,
			numOfItemsInFileWithAcceptableNotes: 0,
			numItemsInDebt: 0,
			numSuccefulyUpdatedItems: 0,
			numErrors: 0,
			numSuccefulyAddedItems: 0,
			updateSuccess: null
		}
	},
	watch: {
	},
	computed: {
		modalSize () {
			if (this.updateSuccess > 0) return 'xl';
			return 'md';
		},
		uploadPlaceholder () {
			return PH_TEXT;
		},
		okButtonDisabled () {
			if (this.okButton.disabled && !this.spOrderItemsUpdateStatusFile) {
				return true;
			}
			return false;
		}
	},
	created () {
	}
}
</script>

<style scoped>
.ma_pos {
	text-align: end;
}
.numberCardHeader {
	min-height: 5.5rem;
}
</style>